/**
 * ProgressiveJackpotResult.ts
 */
export class ProgressiveJackpotResult {
    constructor(responseCode, data) {
        this.responseCode = responseCode;
        this.data = data;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=ProgressiveJackpotResult.js.map